import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/auth.service';
import { GlobalService } from 'src/app/global.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserListService {

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private globalService: GlobalService
  ) {}

  async getUserList(req_param:any){
    var isTokenValid = await this.authService.checkAccessTokenValidity();
    
    if (isTokenValid) {
      var APIEndPoint:string = `${environment.cignalApiUrl}/userList/`;

      var body:any = req_param;

      try {
        var response = await lastValueFrom<HttpResponse<any>>(
          this.http.post(APIEndPoint, body, {
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("access_token")}`
              },
              observe: 'response',
            }
          )
        );  
        return {
          "total": response.body.total,
          "items": response.body.items,
          "hierarchy": response.body.hierarchy,
          "message": "",
        }; 
      }catch (e:any) {
        console.log(e.error.message);
        return {
          "total": 0,
          "items": [],
          "hierarchy": [],
          "message": e.error.message,
        }; 
      }

    }else{
      return false;
    }
  }
  async getUserByHierarchy(req_param:any){
    var isTokenValid = await this.authService.checkAccessTokenValidity();
    
    if (isTokenValid) {
      var APIEndPoint:string = `${environment.cignalApiUrl}/userList/byHierarchy`;

      var body:any = req_param;

      try {
        var response = await lastValueFrom<HttpResponse<any>>(
          this.http.post(APIEndPoint, body, {
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("access_token")}`
              },
              observe: 'response',
            }
          )
        );  
        return {
          "total": response.body.total,
          "items": response.body.items,
          "hierarchy": response.body.hierarchy,
          "message": "",
        }; 
      }catch (e:any) {
        console.log(e.error.message);
        return {
          "total": 0,
          "items": [],
          "hierarchy": [],
          "message": e.error.message,
        }; 
      }

    }else{
      return false;
    }
  }
  async getUserDetails(user_id:any){
    var isTokenValid = await this.authService.checkAccessTokenValidity();
    
    if (isTokenValid) {
      var APIEndPoint:string = `${environment.cignalApiUrl}/userList/userDetails`;

      var body:any = {"user_id": `${user_id}`};

      try {
        var response = await lastValueFrom<HttpResponse<any>>(
          this.http.post(APIEndPoint, body, {
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("access_token")}`
              },
              observe: 'response',
            }
          )
        );  
        return {
          "items": response.body.items[0],
          "message": "",
        }; 
      }catch (e:any) {
        console.log(e.error.message);
        return {
          "items": {},
          "message": e.error.message,
        }; 
      }

    }else{
      return false;
    }
  }

  async exportUserList(requestParam:any){
    var isTokenValid = await this.authService.checkAccessTokenValidity();
    if (isTokenValid) {
      var APIEndPoint:string = `${environment.cignalApiUrl}/download/userList/`;
      requestParam.username = this.globalService.getUserInformation().username;
      var body = requestParam;
      try {
        var response = await lastValueFrom<HttpResponse<any>>(
          this.http.post(APIEndPoint, body, {
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("access_token")}`
              },
              observe: 'response',
            }
          )
        );
        return {
          "success": true,
          "message": response.body.message
        };
      } catch (e:any) {
        return {
          "success": false,
          "message": e.error.message
        }; 
      }
    }else{
      return false;
    }
  }
}
